export default "__VITE_ASSET__DJuWfLSE__"